import React from "react"
import Icon from "../../../icon/icon.component"
import { BundleOptionsDisplayProps } from "../../../types"

const BundleOptionsDisplay = (props: BundleOptionsDisplayProps) => {
    let bundleItems = props.product.getBundle().getAttributes().bundleProducts
    if (props.itemsOverride) {
        bundleItems = props.itemsOverride
    }

    return(
        <div>
            <div className="w-100 d-flex flex-column">
                {bundleItems?.map((item, index) => (
                    <>
                        <span key={index}>{item.quantity ?? item.measure} x {item.title}</span>
                        {props.showBundleSkus && (
                            <p className="p-0 m-0 mb-1 text-secondary small">
                                <Icon value="hashtag" className="mr-1" />
                                {item.product.sku}
                            </p>
                        )}
                    </>
                ))}
            </div>
        </div>
    )
}

export default BundleOptionsDisplay


// WEBPACK FOOTER //
// ./src/common/pricing/add-item-modal/components/BundleOptionsDisplay.tsx